import { EnumOption } from "lib/models/aiforme-models";
import { useEffect, useState } from "react";

import { AIForMeDataService, AIForMeDataServiceFactory } from "../lib/services/aiforme-service";

export const useAIForMeData = () => {
  const [categories, setCategories] = useState<string[]>([]);
  const [jobFamilies, setJobFamilies] = useState<string[]>([]);
  const [dataClassifications, setDataClassifications] = useState<string[]>([]);
  const [sortingPriority, setSortingPriority] = useState<{ [key: number]: string }>({});
  const [loadingAIForMe, setLoadingAIForMe] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [availableModels, setAvailableModels] = useState<string[]>([]);
  const RECOMMENDED_CATEGORY = "Recommended";
  const ALL_JOB_FAMILY_CATEGORY = "All";

  useEffect(() => {
    const provider: AIForMeDataService = AIForMeDataServiceFactory.create();
    provider
      .getMetadata()
      .then((metadata) => {
        const categoryLabels = metadata.enums.categories?.map((enumOption: EnumOption) => enumOption.label) || [];
        // We want to display Recommended on top.
        const sortedCategories = categoryLabels.sort((categoryLabelA, categoryLabelB) => {
          if (categoryLabelA === RECOMMENDED_CATEGORY) return -1;
          if (categoryLabelB === RECOMMENDED_CATEGORY) return 1;
          return categoryLabelA.localeCompare(categoryLabelB);
        });
        setCategories(sortedCategories);
        const jobFamilyLabels = metadata.enums.jobFamilies?.map((enumOption: EnumOption) => enumOption.label) || [];
        const sortedJobFamilies = jobFamilyLabels
          .filter((label) => label !== ALL_JOB_FAMILY_CATEGORY)
          .sort((jobFamilyLabelA, jobFamilyLabelB) => jobFamilyLabelA.localeCompare(jobFamilyLabelB));
        setJobFamilies(sortedJobFamilies);
        const dataClassificationLabels =
          metadata.enums.dataClassification?.map((enumOption: EnumOption) => enumOption.label) || [];
        const hasPublicData = dataClassificationLabels.includes("Public Data");
        const dataClassifications = dataClassificationLabels.filter(
          (label) => label === "Business Data" || label === "Public Data" || (!hasPublicData && label === "Public")
        );
        setDataClassifications(dataClassifications);
        const availableModelLabels = metadata.enums.modelsUsed?.map((enumOption: EnumOption) => enumOption.label) || [];
        setAvailableModels(availableModelLabels);

        const sortingPriorityDict: { [key: number]: string } = {};
        metadata.enums.sortingPriority?.map((enumOption: EnumOption) => {
          sortingPriorityDict[enumOption.value as number] = enumOption.label;
        });

        setSortingPriority(sortingPriorityDict);
        setLoadingAIForMe(false);
      })
      .catch((error) => {
        setLoadingAIForMe(false);
        setHasError(error);
      });
  }, []);

  return { categories, jobFamilies, sortingPriority, dataClassifications, availableModels, loadingAIForMe, hasError };
};
